import reducer from './instrumentReducer';
import * as selectors from './selectors';

export default reducer;
export { selectors };
